var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16104",
    "data-name": "Group 16104",
    transform: "translate(-1544 -143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1544 143)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16105",
    "data-name": "Group 16105",
    transform: "translate(1547 146.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11392",
    "data-name": "Path 11392",
    d: "M21.086,212.682A10.477,10.477,0,0,0,17.177,212a10.477,10.477,0,0,0-3.909.682A4.2,4.2,0,0,0,12,213.46a4.2,4.2,0,0,0-1.267-.779A10.477,10.477,0,0,0,6.824,212a10.477,10.477,0,0,0-3.909.682C1.68,213.2,1,213.95,1,214.8v5.177c0,.854.68,1.608,1.914,2.123a10.067,10.067,0,0,0,3.4.671,3.138,3.138,0,0,0,1.781,1.486,10.477,10.477,0,0,0,3.909.682,10.477,10.477,0,0,0,3.909-.682,3.138,3.138,0,0,0,1.781-1.486,10.066,10.066,0,0,0,3.4-.671c1.235-.514,1.914-1.268,1.914-2.123V214.8C23,213.95,22.321,213.2,21.086,212.682Zm-3.909.613c2.931,0,4.53,1,4.53,1.51,0,.482-1.416,1.394-4.025,1.5a3.162,3.162,0,0,0-1.772-1.465,9.51,9.51,0,0,0-2.772-.632A7.61,7.61,0,0,1,17.177,213.294ZM12,215.451c2.931,0,4.53,1,4.53,1.51s-1.6,1.51-4.53,1.51-4.53-1-4.53-1.51S9.07,215.451,12,215.451Zm-4.53,3.327a5.261,5.261,0,0,0,.62.305,10.476,10.476,0,0,0,3.909.682,10.476,10.476,0,0,0,3.909-.682,5.264,5.264,0,0,0,.62-.305v.771c0,.512-1.6,1.51-4.53,1.51s-4.53-1-4.53-1.51Zm-.647-5.484a7.611,7.611,0,0,1,4.039.913,9.513,9.513,0,0,0-2.772.632A3.162,3.162,0,0,0,6.319,216.3c-2.609-.106-4.025-1.017-4.025-1.5C2.294,214.292,3.893,213.294,6.824,213.294Zm-4.53,3.327a5.266,5.266,0,0,0,.62.305,9.954,9.954,0,0,0,3.262.665v1.293c-2.518-.133-3.883-1.019-3.883-1.492Zm0,3.359v-.771a5.256,5.256,0,0,0,.62.305,9.953,9.953,0,0,0,3.262.665v1.293C3.659,221.34,2.294,220.454,2.294,219.981ZM12,223.648c-2.931,0-4.53-1-4.53-1.51v-.771a5.27,5.27,0,0,0,.62.305,10.477,10.477,0,0,0,3.909.682,10.477,10.477,0,0,0,3.909-.682,5.273,5.273,0,0,0,.62-.305v.771C16.53,222.65,14.931,223.648,12,223.648Zm5.824-2.174V220.18a9.953,9.953,0,0,0,3.262-.665,5.259,5.259,0,0,0,.62-.305v.771C21.707,220.454,20.342,221.34,17.824,221.473Zm0-2.588v-1.293a9.954,9.954,0,0,0,3.262-.665,5.268,5.268,0,0,0,.62-.305v.771C21.707,217.866,20.342,218.752,17.824,218.885Z",
    transform: "translate(-0.001 -202.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11393",
    "data-name": "Path 11393",
    d: "M181.646,3.882h.647V7.117a.647.647,0,0,0,.647.647h2.588a.647.647,0,0,0,.647-.647V3.882h.647a.647.647,0,0,0,.458-1.1L184.692.189a.647.647,0,0,0-.915,0l-2.588,2.588a.647.647,0,0,0,.458,1.1Zm2.588-2.32L185.3,2.629a.648.648,0,0,0-.42.606V6.47h-1.294V3.235a.647.647,0,0,0-.42-.606Z",
    transform: "translate(-172.235 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11394",
    "data-name": "Path 11394",
    d: "M1.646,23.883h.647v2.373a.647.647,0,0,0,.647.647H5.529a.647.647,0,0,0,.647-.647V23.883h.647a.647.647,0,0,0,.458-1.1L4.692,20.19a.647.647,0,0,0-.915,0L1.189,22.778a.647.647,0,0,0,.458,1.1Zm2.588-2.32L5.3,22.63a.647.647,0,0,0-.42.606v2.373H3.588V23.236a.647.647,0,0,0-.42-.606Z",
    transform: "translate(0 -19.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11395",
    "data-name": "Path 11395",
    d: "M361.646,23.883h.647v2.373a.647.647,0,0,0,.647.647h2.588a.647.647,0,0,0,.647-.647V23.883h.647a.647.647,0,0,0,.458-1.1l-2.588-2.588a.647.647,0,0,0-.915,0l-2.588,2.588a.647.647,0,0,0,.458,1.1Zm2.588-2.32L365.3,22.63a.647.647,0,0,0-.42.606v2.373h-1.294V23.236a.647.647,0,0,0-.42-.606Z",
    transform: "translate(-344.47 -19.138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.889990731844cdaf1b898ae256bfe345.svg";
export { ForwardRef as ReactComponent };